"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.from");

var _slicedToArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/slicedToArray.js"));

require("core-js/modules/es7.object.entries");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.string.includes");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _toConsumableArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var _installTask = require("@/api/cms/installTask");

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default2 = {
  name: 'TaskInfo',
  props: {
    taskList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    sendData: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      addDialogVisible: false,
      addTableLoading: false,
      addContractList: [],
      addSelectedContracts: [],
      addSelectedDesignSchemes: [],
      addSelectedOrderSolutions: [],
      isBatchToggling: false
    };
  },
  methods: {
    handleRowClick: function handleRowClick(row, column, event) {
      if (column.type === 'expand') {
        return;
      }

      event.target.closest('.el-table__row').querySelector('.el-table__expand-icon').click();
    },
    handleAdd: function handleAdd(row) {
      this.addDialogVisible = true;
    },
    handleCancel: function handleCancel(row) {
      var _this = this;

      this.$confirm('确定要取消该条任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '返回',
        type: 'warning'
      }).then(function () {
        _this.doCancel(row);
      }).catch(function () {});
    },
    doCancel: function doCancel(row) {
      var _this2 = this;

      if (!this.sendData || !this.sendData.id) {
        this.$message.error('缺少安装工单信息');
        return;
      }

      var remainingData = this.extractExistingTaskDataExcluding(row);
      var send = this.sendData;
      var submitData = {
        id: send.id,
        installCode: send.installCode,
        customer: send.customer,
        customerPhone: send.customerPhone,
        customerAddress: send.customerAddress,
        productType: send.productType,
        isIn: send.isIn,
        installDate: send.installDate,
        installTime: send.installTime,
        installMamager: send.installMamager,
        installGroup: send.installGroup,
        installPerson: send.installPerson,
        openWay: send.openWay,
        openRemark: send.openRemark,
        contractIds: remainingData.contractIds,
        auditSolutionRelations: remainingData.auditSolutionRelations,
        remark: send.remark || '',
        status: send.status
      };
      (0, _installTask.updateInstallTask)(submitData).then(function (response) {
        if (response.code === 200) {
          _this2.$message.success('取消成功');

          _this2.$emit('refresh');
        } else {
          _this2.$message.error(response.msg || '取消失败');
        }
      }).catch(function () {
        _this2.$message.error('网络错误，请稍后重试');
      });
    },
    extractExistingTaskDataExcluding: function extractExistingTaskDataExcluding(excludeRow) {
      var solutionIds = [];
      var auditSolutionRelations = [];
      var contractIds = [];
      var excludeSolutions = new Set();
      var excludeDesigns = new Set();
      var excludeContracts = new Set();

      if (excludeRow.solutionName !== undefined) {
        excludeSolutions.add(excludeRow.id);
      } else if (excludeRow.auditCode !== undefined) {
        excludeDesigns.add(excludeRow.id);
        (excludeRow.orderSolutions || []).forEach(function (os) {
          return excludeSolutions.add(os.id);
        });
      } else if (excludeRow.contractNo !== undefined) {
        excludeContracts.add(excludeRow.id || excludeRow.contractId);
        (excludeRow.designSchemes || []).forEach(function (ds) {
          excludeDesigns.add(ds.id);
          (ds.orderSolutions || []).forEach(function (os) {
            return excludeSolutions.add(os.id);
          });
        });
      }

      if (!this.taskList) {
        return {
          solutionIds: solutionIds,
          contractIds: contractIds,
          auditSolutionRelations: auditSolutionRelations
        };
      }

      this.taskList.forEach(function (task) {
        ;
        (task.contractList || []).forEach(function (contract) {
          var contractId = contract.id || contract.contractId;
          if (excludeContracts.has(contractId)) return;

          if (!contractIds.includes(contractId)) {
            contractIds.push(contractId);
          }

          var dsIds = [];
          (contract.designSchemes || []).forEach(function (ds) {
            if (excludeDesigns.has(ds.id)) return;
            var osIds = (ds.orderSolutions || []).filter(function (os) {
              return !excludeSolutions.has(os.id);
            }).map(function (os) {
              return os.id;
            });
            solutionIds.push.apply(solutionIds, (0, _toConsumableArray2.default)(osIds));
            dsIds.push.apply(dsIds, (0, _toConsumableArray2.default)(osIds));

            if (osIds.length > 0) {
              auditSolutionRelations.push({
                auditId: ds.id,
                orderSolutionIds: osIds
              });
            }
          });

          if (dsIds.length === 0) {
            contractIds.splice(contractIds.indexOf(contractId), 1);
          }
        });
      });
      return {
        solutionIds: solutionIds,
        contractIds: contractIds,
        auditSolutionRelations: auditSolutionRelations
      };
    },
    loadAddTableData: function loadAddTableData() {
      var _this3 = this;

      this.addTableLoading = true;
      var existingIds = this.getExistingSolutionIds();
      var params = {
        page: 0,
        size: 50,
        hasSolution: false
      };
      (0, _installTask.getPendingTree)(params).then(function (response) {
        if (response.code === 200) {
          var rawList = response.data.content || [];
          _this3.addContractList = rawList.map(function (contract) {
            var designSchemes = (contract.designSchemes || []).map(function (ds) {
              var orderSolutions = (ds.orderSolutions || []).filter(function (os) {
                return !existingIds.has(os.id);
              });
              return _objectSpread(_objectSpread({}, ds), {}, {
                orderSolutions: orderSolutions
              });
            }).filter(function (ds) {
              return ds.orderSolutions.length > 0;
            });
            return _objectSpread(_objectSpread({}, contract), {}, {
              designSchemes: designSchemes
            });
          }).filter(function (contract) {
            return contract.designSchemes.length > 0;
          });
        } else {
          _this3.$message.error(response.msg || '加载失败');
        }
      }).catch(function () {
        _this3.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this3.addTableLoading = false;
      });
    },
    getExistingSolutionIds: function getExistingSolutionIds() {
      var ids = new Set();
      if (!this.taskList) return ids;
      this.taskList.forEach(function (task) {
        ;
        (task.contractList || []).forEach(function (contract) {
          ;
          (contract.designSchemes || []).forEach(function (ds) {
            ;
            (ds.orderSolutions || []).forEach(function (os) {
              if (os.id) ids.add(os.id);
            });
          });
        });
      });
      return ids;
    },
    handleAddContractSelectionChange: function handleAddContractSelectionChange(selection) {
      var _this4 = this;

      if (this.isBatchToggling) return;
      var currentChecked = selection.map(function (item) {
        return item.contractId;
      });
      var previousChecked = this.addSelectedContracts.map(function (item) {
        return item.contractId;
      });
      var newlyChecked = currentChecked.filter(function (id) {
        return !previousChecked.includes(id);
      });
      var unchecked = previousChecked.filter(function (id) {
        return !currentChecked.includes(id);
      });
      this.addSelectedContracts = selection;

      if (newlyChecked.length > 0) {
        var newDesigns = [];
        var newSolutions = [];
        newlyChecked.forEach(function (contractId) {
          var contract = _this4.addContractList.find(function (c) {
            return c.contractId === contractId;
          });

          if (contract && contract.designSchemes) {
            contract.designSchemes.forEach(function (ds) {
              if (!_this4.addSelectedDesignSchemes.some(function (d) {
                return d.id === ds.id;
              })) {
                newDesigns.push(ds);
              }

              if (ds.orderSolutions) {
                ds.orderSolutions.forEach(function (os) {
                  if (!_this4.addSelectedOrderSolutions.some(function (o) {
                    return o.id === os.id;
                  })) {
                    newSolutions.push(os);
                  }
                });
              }
            });
          }
        });
        this.addSelectedDesignSchemes = [].concat((0, _toConsumableArray2.default)(this.addSelectedDesignSchemes), newDesigns);
        this.addSelectedOrderSolutions = [].concat((0, _toConsumableArray2.default)(this.addSelectedOrderSolutions), newSolutions);
        this.isBatchToggling = true;
        this.$nextTick(function () {
          newlyChecked.forEach(function (contractId) {
            var contract = _this4.addContractList.find(function (c) {
              return c.contractId === contractId;
            });

            if (!contract || !contract.designSchemes) return;

            _this4.toggleContractChildren(contract, true);
          });
          _this4.isBatchToggling = false;
        });
      }

      if (unchecked.length > 0) {
        var uncheckedDsIds = new Set();
        var uncheckedOsIds = new Set();
        unchecked.forEach(function (contractId) {
          var contract = _this4.addContractList.find(function (c) {
            return c.contractId === contractId;
          });

          if (contract && contract.designSchemes) {
            contract.designSchemes.forEach(function (ds) {
              uncheckedDsIds.add(ds.id);

              if (ds.orderSolutions) {
                ds.orderSolutions.forEach(function (os) {
                  return uncheckedOsIds.add(os.id);
                });
              }
            });
          }
        });
        this.addSelectedDesignSchemes = this.addSelectedDesignSchemes.filter(function (d) {
          return !uncheckedDsIds.has(d.id);
        });
        this.addSelectedOrderSolutions = this.addSelectedOrderSolutions.filter(function (o) {
          return !uncheckedOsIds.has(o.id);
        });
        this.isBatchToggling = true;
        this.$nextTick(function () {
          unchecked.forEach(function (contractId) {
            var contract = _this4.addContractList.find(function (c) {
              return c.contractId === contractId;
            });

            if (!contract || !contract.designSchemes) return;

            _this4.toggleContractChildren(contract, false);
          });
          _this4.isBatchToggling = false;
        });
      }
    },
    toggleContractChildren: function toggleContractChildren(contract, selected) {
      var _this5 = this;

      var designTable = this.$refs['addDesignTable_' + contract.contractId];

      if (designTable) {
        var table = Array.isArray(designTable) ? designTable[0] : designTable;

        if (table && contract.designSchemes) {
          contract.designSchemes.forEach(function (ds) {
            table.toggleRowSelection(ds, selected);

            _this5.toggleDesignChildren(ds, selected);
          });
        }
      }
    },
    toggleDesignChildren: function toggleDesignChildren(ds, selected) {
      var solutionTable = this.$refs['addSolutionTable_' + ds.id];

      if (solutionTable) {
        var table = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

        if (table && ds.orderSolutions) {
          ds.orderSolutions.forEach(function (os) {
            return table.toggleRowSelection(os, selected);
          });
        }
      }
    },
    handleAddDesignSelectionChange: function handleAddDesignSelectionChange(selection) {
      var _this6 = this;

      if (this.isBatchToggling) return;
      var currentChecked = selection.map(function (item) {
        return item.id;
      });
      var previousChecked = this.addSelectedDesignSchemes.map(function (item) {
        return item.id;
      });
      var newlyChecked = currentChecked.filter(function (id) {
        return !previousChecked.includes(id);
      });
      var unchecked = previousChecked.filter(function (id) {
        return !currentChecked.includes(id);
      });
      this.addSelectedDesignSchemes = selection;

      if (newlyChecked.length > 0) {
        var newSolutions = [];
        var newContracts = [];
        newlyChecked.forEach(function (dsId) {
          var ds = _this6.findDesignScheme(dsId);

          if (ds && ds.orderSolutions) {
            ds.orderSolutions.forEach(function (os) {
              if (!_this6.addSelectedOrderSolutions.some(function (o) {
                return o.id === os.id;
              })) {
                newSolutions.push(os);
              }
            });
          }

          var parent = _this6.findDesignParent(dsId);

          if (parent && parent.contract && !newContracts.some(function (c) {
            return c.contractId === parent.contract.contractId;
          })) {
            newContracts.push(parent.contract);
          }
        });
        this.addSelectedOrderSolutions = [].concat((0, _toConsumableArray2.default)(this.addSelectedOrderSolutions), newSolutions);
        this.addSelectedContracts = [].concat((0, _toConsumableArray2.default)(this.addSelectedContracts), newContracts);
        this.isBatchToggling = true;
        this.$nextTick(function () {
          newlyChecked.forEach(function (dsId) {
            var ds = _this6.findDesignScheme(dsId);

            if (ds) _this6.toggleDesignChildren(ds, true);
          });
          newContracts.forEach(function (contract) {
            if (_this6.$refs.addContractTable) {
              _this6.$refs.addContractTable.toggleRowSelection(contract, true);
            }
          });
          _this6.isBatchToggling = false;
        });
      }

      if (unchecked.length > 0) {
        var uncheckedOsIds = new Set();
        unchecked.forEach(function (dsId) {
          var ds = _this6.findDesignScheme(dsId);

          if (ds && ds.orderSolutions) {
            ds.orderSolutions.forEach(function (os) {
              return uncheckedOsIds.add(os.id);
            });
          }
        });
        this.addSelectedOrderSolutions = this.addSelectedOrderSolutions.filter(function (o) {
          return !uncheckedOsIds.has(o.id);
        });
        this.isBatchToggling = true;
        this.$nextTick(function () {
          unchecked.forEach(function (dsId) {
            var ds = _this6.findDesignScheme(dsId);

            if (ds) _this6.toggleDesignChildren(ds, false);
          });
          _this6.isBatchToggling = false;
        });
      }
    },
    findDesignScheme: function findDesignScheme(id) {
      var _iterator = _createForOfIteratorHelper(this.addContractList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var contract = _step.value;

          if (contract.designSchemes) {
            var ds = contract.designSchemes.find(function (d) {
              return d.id === id;
            });
            if (ds) return ds;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    },
    findDesignParent: function findDesignParent(dsId) {
      var _iterator2 = _createForOfIteratorHelper(this.addContractList),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var contract = _step2.value;

          if (contract.designSchemes && contract.designSchemes.some(function (d) {
            return d.id === dsId;
          })) {
            return {
              contract: contract
            };
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return null;
    },
    handleAddSolutionSelectionChange: function handleAddSolutionSelectionChange(selection) {
      var _this7 = this;

      if (this.isBatchToggling) return;
      var currentChecked = selection.map(function (item) {
        return item.id;
      });
      var previousChecked = this.addSelectedOrderSolutions.map(function (item) {
        return item.id;
      });
      var newlyChecked = currentChecked.filter(function (id) {
        return !previousChecked.includes(id);
      });
      var unchecked = previousChecked.filter(function (id) {
        return !currentChecked.includes(id);
      });
      this.addSelectedOrderSolutions = selection;

      if (newlyChecked.length > 0) {
        var newDesigns = [];
        var newContracts = [];
        newlyChecked.forEach(function (osId) {
          var parent = _this7.findSolutionParent(osId);

          if (parent && parent.ds) {
            if (!_this7.addSelectedDesignSchemes.some(function (d) {
              return d.id === parent.ds.id;
            })) {
              newDesigns.push(parent.ds);
            }

            if (parent.contract && !_this7.addSelectedContracts.some(function (c) {
              return c.contractId === parent.contract.contractId;
            })) {
              newContracts.push(parent.contract);
            }
          }
        });
        this.addSelectedDesignSchemes = [].concat((0, _toConsumableArray2.default)(this.addSelectedDesignSchemes), newDesigns);
        this.addSelectedContracts = [].concat((0, _toConsumableArray2.default)(this.addSelectedContracts), newContracts);
        this.isBatchToggling = true;
        this.$nextTick(function () {
          newDesigns.forEach(function (ds) {
            var parent = _this7.findSolutionParent(ds.orderSolutions && ds.orderSolutions[0] && ds.orderSolutions[0].id);

            if (parent && parent.contract) {
              var designTable = _this7.$refs['addDesignTable_' + parent.contract.contractId];

              if (designTable) {
                var table = Array.isArray(designTable) ? designTable[0] : designTable;

                if (table) {
                  table.toggleRowSelection(ds, true);
                }
              }
            }
          });
          newContracts.forEach(function (contract) {
            if (_this7.$refs.addContractTable) {
              _this7.$refs.addContractTable.toggleRowSelection(contract, true);
            }
          });
          _this7.isBatchToggling = false;
        });
      }

      if (unchecked.length > 0) {
        var designSolutionCounts = {};
        unchecked.forEach(function (osId) {
          var parent = _this7.findSolutionParent(osId);

          if (parent && parent.ds) {
            var dsId = parent.ds.id;

            if (!designSolutionCounts[dsId]) {
              designSolutionCounts[dsId] = {
                ds: parent.ds,
                contract: parent.contract,
                remaining: 0
              };
            }

            var remaining = _this7.addSelectedOrderSolutions.filter(function (s) {
              return s.id !== osId && parent.ds.orderSolutions && parent.ds.orderSolutions.some(function (o) {
                return o.id === s.id;
              });
            });

            designSolutionCounts[dsId].remaining = remaining.length;
          }
        });
        var toRemoveDsIds = [];
        var toRemoveContractIds = [];
        Object.values(designSolutionCounts).forEach(function (item) {
          if (item.remaining === 0) {
            toRemoveDsIds.push(item.ds.id);

            if (item.contract) {
              var contractDsRemaining = _this7.addSelectedDesignSchemes.filter(function (d) {
                return d.id !== item.ds.id && item.contract.designSchemes && item.contract.designSchemes.some(function (cd) {
                  return cd.id === d.id;
                });
              });

              if (contractDsRemaining.length === 0) {
                toRemoveContractIds.push(item.contract.contractId);
              }
            }
          }
        });
        this.addSelectedDesignSchemes = this.addSelectedDesignSchemes.filter(function (d) {
          return !toRemoveDsIds.includes(d.id);
        });
        this.addSelectedContracts = this.addSelectedContracts.filter(function (c) {
          return !toRemoveContractIds.includes(c.contractId);
        });
        this.isBatchToggling = true;
        this.$nextTick(function () {
          toRemoveContractIds.forEach(function (contractId) {
            var contract = _this7.addContractList.find(function (c) {
              return c.contractId === contractId;
            });

            if (contract && _this7.$refs.addContractTable) {
              _this7.$refs.addContractTable.toggleRowSelection(contract, false);
            }
          });
          _this7.isBatchToggling = false;
        });
      }
    },
    findSolutionParent: function findSolutionParent(osId) {
      var _iterator3 = _createForOfIteratorHelper(this.addContractList),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var contract = _step3.value;

          if (contract.designSchemes) {
            var _iterator4 = _createForOfIteratorHelper(contract.designSchemes),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var ds = _step4.value;

                if (ds.orderSolutions && ds.orderSolutions.some(function (os) {
                  return os.id === osId;
                })) {
                  return {
                    ds: ds,
                    contract: contract
                  };
                }
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return null;
    },
    handleAddContractRowClick: function handleAddContractRowClick(row, column) {
      if (column && column.type === 'selection') return;

      if (this.$refs.addContractTable) {
        this.$refs.addContractTable.toggleRowExpansion(row);
      }
    },
    handleAddDesignRowClick: function handleAddDesignRowClick(row, column) {
      if (column && column.type === 'selection') return;
      var contract = this.addContractList.find(function (c) {
        return c.designSchemes && c.designSchemes.some(function (ds) {
          return ds.id === row.id;
        });
      });

      if (contract) {
        var table = this.$refs['addDesignTable_' + contract.contractId];

        if (table) {
          var tableInstance = Array.isArray(table) ? table[0] : table;

          if (tableInstance) {
            tableInstance.toggleRowExpansion(row);
          }
        }
      }
    },
    handleAddContractExpandChange: function handleAddContractExpandChange(row, expanded) {
      var _this8 = this;

      if (expanded && row.designSchemes) {
        var checkedDsIds = new Set(this.addSelectedDesignSchemes.map(function (d) {
          return d.id;
        }));
        this.$nextTick(function () {
          var designTable = _this8.$refs['addDesignTable_' + row.contractId];

          if (designTable) {
            var table = Array.isArray(designTable) ? designTable[0] : designTable;

            if (table && row.designSchemes) {
              row.designSchemes.forEach(function (ds) {
                if (checkedDsIds.has(ds.id)) {
                  table.toggleRowSelection(ds, true);
                }
              });
            }
          }
        });
      }
    },
    handleAddDesignExpandChange: function handleAddDesignExpandChange(row, expanded) {
      var _this9 = this;

      if (expanded && row.orderSolutions) {
        var checkedOsIds = new Set(this.addSelectedOrderSolutions.map(function (o) {
          return o.id;
        }));
        this.$nextTick(function () {
          var solutionTable = _this9.$refs['addSolutionTable_' + row.id];

          if (solutionTable) {
            var table = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

            if (table && row.orderSolutions) {
              row.orderSolutions.forEach(function (os) {
                if (checkedOsIds.has(os.id)) {
                  table.toggleRowSelection(os, true);
                }
              });
            }
          }
        });
      }
    },
    confirmAdd: function confirmAdd() {
      var _this10 = this;

      var hasContractSelection = this.addSelectedContracts.length > 0;
      var hasDesignSelection = this.addSelectedDesignSchemes.length > 0;
      var hasSolutionSelection = this.addSelectedOrderSolutions.length > 0;

      if (!hasContractSelection && !hasDesignSelection && !hasSolutionSelection) {
        this.$message.warning('请先选择要添加的数据');
        return;
      }

      if (!this.sendData || !this.sendData.id) {
        this.$message.error('缺少安装工单信息');
        return;
      }

      var existingData = this.extractExistingTaskData();
      var allSolutionIds = [].concat((0, _toConsumableArray2.default)(existingData.solutionIds), (0, _toConsumableArray2.default)(this.addSelectedOrderSolutions.map(function (s) {
        return s.id;
      })));
      var allAuditRelations = this.mergeAuditRelations(existingData.auditSolutionRelations, this.addSelectedDesignSchemes, this.addSelectedOrderSolutions);
      var allContractIds = this.mergeContractIds(existingData.contractIds, this.addSelectedContracts, this.addSelectedDesignSchemes);
      var send = this.sendData;
      var submitData = {
        id: send.id,
        installCode: send.installCode,
        customer: send.customer,
        customerPhone: send.customerPhone,
        customerAddress: send.customerAddress,
        productType: send.productType,
        isIn: send.isIn,
        installDate: send.installDate,
        installTime: send.installTime,
        installMamager: send.installMamager,
        installGroup: send.installGroup,
        installPerson: send.installPerson,
        openWay: send.openWay,
        openRemark: send.openRemark,
        contractIds: allContractIds,
        auditSolutionRelations: allAuditRelations,
        remark: send.remark || '',
        status: send.status
      };
      (0, _installTask.updateInstallTask)(submitData).then(function (response) {
        if (response.code === 200) {
          _this10.$message.success('添加成功');

          _this10.$emit('refresh');
        } else {
          _this10.$message.error(response.msg || '添加失败');
        }
      }).catch(function () {
        _this10.$message.error('网络错误，请稍后重试');
      });
      this.addDialogVisible = false;
    },
    extractExistingTaskData: function extractExistingTaskData() {
      var solutionIds = [];
      var auditSolutionRelations = [];
      var contractIds = [];

      if (!this.taskList) {
        return {
          solutionIds: solutionIds,
          contractIds: contractIds,
          auditSolutionRelations: auditSolutionRelations
        };
      }

      this.taskList.forEach(function (task) {
        ;
        (task.contractList || []).forEach(function (contract) {
          if (!contractIds.includes(contract.id || contract.contractId)) {
            contractIds.push(contract.id || contract.contractId);
          }

          ;
          (contract.designSchemes || []).forEach(function (ds) {
            var existingDsIds = (ds.orderSolutions || []).map(function (os) {
              return os.id;
            });
            solutionIds.push.apply(solutionIds, (0, _toConsumableArray2.default)(existingDsIds));

            if (existingDsIds.length > 0) {
              auditSolutionRelations.push({
                auditId: ds.id,
                orderSolutionIds: existingDsIds
              });
            }
          });
        });
      });
      return {
        solutionIds: solutionIds,
        contractIds: contractIds,
        auditSolutionRelations: auditSolutionRelations
      };
    },
    mergeAuditRelations: function mergeAuditRelations(existingRelations, newDesignSchemes, newOrderSolutions) {
      var relationMap = {};
      existingRelations.forEach(function (rel) {
        if (!relationMap[rel.auditId]) {
          relationMap[rel.auditId] = new Set();
        }

        rel.orderSolutionIds.forEach(function (id) {
          return relationMap[rel.auditId].add(id);
        });
      });
      var newSolutionIds = new Set(newOrderSolutions.map(function (s) {
        return s.id;
      }));
      newDesignSchemes.forEach(function (ds) {
        var dsSolutions = (ds.orderSolutions || []).filter(function (os) {
          return newSolutionIds.has(os.id);
        });

        if (dsSolutions.length > 0) {
          if (!relationMap[ds.id]) {
            relationMap[ds.id] = new Set();
          }

          dsSolutions.forEach(function (os) {
            return relationMap[ds.id].add(os.id);
          });
        }
      });
      return Object.entries(relationMap).map(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            auditId = _ref2[0],
            ids = _ref2[1];

        return {
          auditId: auditId,
          orderSolutionIds: Array.from(ids)
        };
      });
    },
    mergeContractIds: function mergeContractIds(existingIds, newContracts, newDesignSchemes) {
      var _this11 = this;

      var merged = new Set(existingIds);
      newContracts.forEach(function (c) {
        return merged.add(c.contractId);
      });
      newDesignSchemes.forEach(function (ds) {
        var _iterator5 = _createForOfIteratorHelper(_this11.addContractList),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var contract = _step5.value;

            if (contract.designSchemes && contract.designSchemes.some(function (d) {
              return d.id === ds.id;
            })) {
              merged.add(contract.contractId);
              break;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      });
      return Array.from(merged);
    },
    handleAddDialogClose: function handleAddDialogClose() {
      this.addSelectedContracts = [];
      this.addSelectedDesignSchemes = [];
      this.addSelectedOrderSolutions = [];
      this.addContractList = [];

      if (this.$refs.addContractTable) {
        this.$refs.addContractTable.clearSelection();
      }
    }
  }
};
exports.default = _default2;